import RestrictMesh from "../resources/restrict-mesh";

class RestrictHighlight extends RestrictMesh {
    constructor() {
        super();
    }
}

export default RestrictHighlight;